import { createFeature, createSelector } from '@ngrx/store';
import { columnConfigReducer, EntityColumnConfigState } from '../reducers/column-config.reducer';

export const columnConfigFeature = createFeature({
  name: 'columnConfig',
  reducer: columnConfigReducer,
});

export const selectColumnConfigState = (state: { columnConfig: EntityColumnConfigState }) => state.columnConfig;

export const selectColumnConfigForEntity = (entity: string) =>
  createSelector(selectColumnConfigState, (state) => state[entity] || [] );

export const columnConfigFeatureSelectors = {
  ...columnConfigFeature,
  selectColumnConfigForEntity,
};
